import {
  call, put, takeLatest, takeEvery, delay, all
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import { actions, actionCreators } from 'react/api/actions/taskScheduler';

function* api(url) {
  return yield call(defaultFetch, url);
}

function* requestTaskSchedulersSaga() {
  const url = 'TaskScheduler/List';
  const response = yield call(api, url);
  const { error } = response;
  if (!error) {
    yield put(actionCreators.requestTaskSchedulersSuccess({ response }));
  }
}

function* executeTaskSchedulerSaga(action) {
  const { payload: { executingId, executingIndex } } = action;
  const url = `TaskScheduler/CheckManually/${executingId}`;
  const response = yield call(api, url);
  const { error } = response;
  if (!error) {
    yield put(actionCreators.executeTaskSchedulerSuccess({ response, executingIndex }));
  } else {
    yield put(actionCreators.executeTaskSchedulerError({ error, executingIndex }));
    yield delay(6000);
    yield put(actionCreators.hideTaskSchedulerAlert({ executingIndex }));
  }
}

function* requestTaskSchedulerLogsSaga(action) {
  const { payload: { activeLog } } = action;
  const url = `TaskSchedulerLog/ListByTaskScheduler/${activeLog.get('id')}`;
  const response = yield call(api, url);
  const { error } = response;
  if (!error) {
    yield put(actionCreators.requestTaskSchedulerLogsSuccess({ response, activeLog }));
  } else {
    yield put(actionCreators.closeTaskSchedulerLogs({ error }));
  }
}

function* watchRequestTaskSchedulers() {
  yield takeLatest(actions.requestTaskSchedulers, requestTaskSchedulersSaga);
}

function* watchExecuteTaskScheduler() {
  yield takeEvery(actions.executeTaskScheduler, executeTaskSchedulerSaga);
}

function* watchRequestTaskSchedulerLogs() {
  yield takeLatest(actions.requestTaskSchedulerLogs, requestTaskSchedulerLogsSaga);
}

export default function* () {
  yield all([
    watchRequestTaskSchedulers(),
    watchExecuteTaskScheduler(),
    watchRequestTaskSchedulerLogs()
  ]);
}
